const TqRequirementCell = ({ tq }) => {
  return (
    <span>
      {tq.requirement}
      {tq.family_component_element}
    </span>
  );
};
export default TqRequirementCell;
